export const adminConstants = {
	INACTIVATE_CLIENT: 'INACTIVATE_CLIENT',
	SUCCESS_INACTIVATE: 'SUCCESS_INACTIVATE',
	FAIL_INACTIVATE: 'FAIL_INACTIVATE',
	GET_BALANCE_POINTS: 'GET_BALANCE_POINTS',
	POINTS_WAS_LOADED: 'POINTS_WAS_LOADED',
	LOADING_POINTS: 'LOADING_POINTS',
	ADD_VIEW_BALANCE_POINTS: 'ADD_VIEW_BALANCE_POINTS'
}
